// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_RPhTa {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 
  "head1 head2"
  "mid1 mid2"
  "table table";
  grid-template-rows: 66px 400px auto;
  column-gap: 30px;
  row-gap: 30px;
  padding: 30px;
}

.area_ng7uY { 
  background-color: #f9fafb;
}

.table_QSMQd {
  grid-area: table;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/storeTraffic/StoreTraffic.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B;;;eAGa;EACb,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas: \n  \"head1 head2\"\n  \"mid1 mid2\"\n  \"table table\";\n  grid-template-rows: 66px 400px auto;\n  column-gap: 30px;\n  row-gap: 30px;\n  padding: 30px;\n}\n\n.area { \n  background-color: #f9fafb;\n}\n\n.table {\n  grid-area: table;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_RPhTa`,
	"area": `area_ng7uY`,
	"table": `table_QSMQd`
};
export default ___CSS_LOADER_EXPORT___;
